






















import Vue from "vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputCheckbox: iwInputCheckbox,
        iwTooltip: iwTooltip,
    },
    data: function () {
        return {
            pathInStore: "property.bedroom.hasDressingRoom",
            inputName: "has-dressing-room",
            specificId: uuidv4() as string
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","APARTMENT","OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },

        hasDressingRoom: {
            get: function(): boolean {
                return this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: value,
                });
            },
        },
    },
});
